module.exports = __webpack_public_path__ + "static/media/img-climber.a26ef37b.svg";